import React from "react";
import Icon from "../../Icon";
import PropTypes from "prop-types";
const NotContent = (props) => {
  const {
    title = "Sin datos disponibles",
    description = `Parece que aún no hay reportes para mostrar. Completa los filtros
        requeridos para generar tu reporte`,
  } = props;
  return (
    <div className="text-center mb-8">
      <Icon icon="sentiment_dissatisfied" size={80} />
      <h1 className="text-4xl font-bold text-slate-900 mb-3 tracking-tight">
        {title}
      </h1>

      <p className="text-lg text-slate-60 mb-4 leading-relaxed">
        {description}
      </p>
    </div>
  );
};
NotContent.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default NotContent;
